import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { usePlan } from "@/lib/use-plan";

export default function ReadOnlyBanner() {
  const { readOnly, effectivePlan } = usePlan();
  if (!readOnly) return null;

  const message = effectivePlan === "past_due"
    ? "Your last payment failed."
    : "Your subscription has ended.";
  const sub = effectivePlan === "past_due"
    ? "Update your payment method to restore full access."
    : "Upgrade to restore full access. Your data is safe.";

  return (
    <div data-testid="readonly-banner" role="alert"
      className="bg-oxblood text-ivory border-b border-oxblood-deep px-6 md:px-10 py-3 flex flex-wrap items-center gap-x-4 gap-y-2 text-sm">
      <AlertTriangle className="w-4 h-4" />
      <span className="font-medium">{message}</span>
      <span className="text-ivory/80">{sub}</span>
      <Link to="/app/settings/billing"
        data-testid="readonly-banner-cta"
        className="ml-auto underline underline-offset-4 font-medium text-ivory hover:text-bone">
        {effectivePlan === "past_due" ? "Update payment" : "Upgrade"}
      </Link>
    </div>
  );
}
